<div style="visibility: hidden; position: fixed" [style.left]="contextMenuPosition.x" [style.top]="contextMenuPosition.y" [matMenuTriggerFor]="contextMenu"></div>
<mat-menu class="avmup-menu" #contextMenu="matMenu">
    @for (menuItem of contextMenuItems; track menuItem.menuItemId; let i = $index) {
        <a class="avmup-menu-item mat-mdc-menu-item" (click)="onContextMenuClick($event, menuItem)">
            <fa-icon [icon]="menuItem.menuItemIcon"></fa-icon>
            <span>{{ menuItem.menuItemText }}</span>
        </a>
    }
</mat-menu>
